export default __webpack_public_path__ + "static/media/chicken_gray.3f5071cb.svg";